import React, { useRef } from "react";

import Box from "./Box";
import Button from "./Button";
import ChevronIcon from "../assets/chevron.svg";
import Link from "next/link";
import PropTypes from "prop-types";
import Text from "./Text";
import { useHovered } from "../core/hooks";

function MediumLink({ text, href, back, ariaLabel }) {
  const ref = useRef(null);
  const hovered = useHovered(ref);

  return (
    <Link href={href} passHref>
      <Button
        ref={ref}
        as="a"
        aria-label={ariaLabel ? ariaLabel : ""}
        display="inline-flex"
        flexDirection={back ? "row-reverse" : "row"}
        alignItems="center"
        cursor="pointer"
      >
        <Box>
          <Text uppercase fontSize={[22, 22, 22, 22]} lineHeight={1}>
            {text}
          </Text>
          <Box
            height="2px"
            mt="1px"
            bg="black"
            width="100%"
            transition="opacity 200ms"
            opacity={hovered ? 0 : 1}
          />
        </Box>
        <Box
          pr={10}
          transition="transform 200ms ease-out"
          transform={
            hovered
              ? `${back ? "" : "rotate(180deg)"} translate3d(-4px, 0, 0)`
              : `${back ? "" : "rotate(180deg)"}`
          }
        >
          <ChevronIcon aria-label="Arrow" />
        </Box>
      </Button>
    </Link>
  );
}

export default MediumLink;

MediumLink.propTypes = {
  text: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  ariaLabel: PropTypes.string,
  back: PropTypes.bool,
};
